var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDark)?_c('MonoLogo'):_c('DefaultLogo')
}
var staticRenderFns = []

export { render, staticRenderFns }